import { ATTACHMENT_MODULE_PREFIX } from '../constants';
export const ATTACHMENT_GET_FILTERED_ATTACHMENTS_SUCCESS = `${ATTACHMENT_MODULE_PREFIX}_GET_FILTERED_ATTACHMENTS_SUCCESS`;
export const ATTACHMENT_GET_FILTERED_ATTACHMENTS_FAILURE = `${ATTACHMENT_MODULE_PREFIX}_GET_FILTERED_ATTACHMENTS_FAILURE`;
export const getFilteredAttachmentsSuccessAction = (payload) => ({
    type: ATTACHMENT_GET_FILTERED_ATTACHMENTS_SUCCESS,
    payload
});
export const getFilteredAttachmentsFailureAction = (failureMessage) => ({
    type: ATTACHMENT_GET_FILTERED_ATTACHMENTS_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=getFilteredAttachmentsActions.js.map